import script from "./CircleImage.vue?vue&type=script&setup=true&lang=js"
export * from "./CircleImage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__